export default "__VITE_ASSET__00a29b56__"